export default "__VITE_PUBLIC_ASSET__5b1b2adb__"